import { useProfiles } from "@api/profiles";
import { useUnmappedCadMaterials } from "@api/unmappedCadMaterials";
import i18n from "@i18n/i18n";
import { Box, Container, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, Typography } from "@mui/material";
import { observer } from "mobx-react";
import { useEffect, useState } from "react";
import UnMappedCadMaterialGrid from "./UnMappedCadMaterialGrid";

export interface DropdownOption {
  label: string;
  value: string;
}

const UnmappedCadMaterialPage = observer(() => {
  const [selectedProfileValue, setSelectedProfileValue] = useState<string>("");
  const unmappedCadMaterials = useUnmappedCadMaterials(selectedProfileValue || null);
  const [profileOptions, setProfileOptions] = useState<DropdownOption[]>([]);
  const selectLabel: DropdownOption = {
    label: i18n.t("unmapped-cad-material-tab.select.profile"),
    value: "",
  };
  const profile = useProfiles();

  useEffect(() => {
    if (profile.data && profile.data.length > 0) {
      const profileOptions = [
        selectLabel,
        ...profile.data.map((profile) => ({
          label: profile.name!,
          value: profile.profileId!,
        })),
      ];

      setProfileOptions(profileOptions as DropdownOption[]);
    }
  }, [profile.data]);

  useEffect(() => {
    unmappedCadMaterials.refetch();
  }, [selectedProfileValue]);

  const handleProfileChange = (event: SelectChangeEvent) => {
    const { value } = event.target;
    setSelectedProfileValue(value as string);
  };

  return (
    <Container maxWidth={false} sx={{ height: "100%" }}>
      <Grid mt={2} container spacing={2} sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Grid size={12} sx={{ display: "flex", flexGrow: 0 }}>
          <Typography variant="h6" fontWeight="bold">
            {i18n.t("unmapped-cad-material-tab.title")}
          </Typography>
        </Grid>
        <Grid size={12} sx={{ display: "flex", flexGrow: 0, justifyContent: "end" }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <InputLabel id="profile-label" sx={{ marginRight: 2 }}>
              {i18n.t("unmapped-cad-material-tab.grid.columns.profile")}
            </InputLabel>
            <Select labelId="profile-select-label" id="profile-select-label" value={selectedProfileValue} onChange={handleProfileChange} displayEmpty sx={{ width: "250px" }}>
              {profileOptions.map((profile) => (
                <MenuItem key={profile.value} value={profile.value}>
                  {profile.label}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Grid>
        <Grid size={12} sx={{ display: "flex", flexGrow: 1, width: "100%", position: "relative" }}>
          <UnMappedCadMaterialGrid profileId={selectedProfileValue} />
        </Grid>
      </Grid>
    </Container>
  );
});

export default UnmappedCadMaterialPage;
